const state = () => ({
  tags: [
    'Work',
    'Home Improvement',
    'Vacation',
    'Food',
    'Drawers',
    'Shopping',
    'Art',
    'Tech',
    'Creative Writing'
  ],
  person: [
    {
      id: 1,
      name: `วรวุธ ฟักนวล`,
      profile_image: `https://cdn.vuetifyjs.com/images/lists/1.jpg`
    },
    {
      id: 2,
      name: `กิตติพร อวยพร`,
      profile_image: `https://cdn.vuetifyjs.com/images/lists/2.jpg`
    },
    {
      id: 3,
      name: `มณีนุช เชิดกลิ่น`,
      profile_image: `https://cdn.vuetifyjs.com/images/lists/3.jpg`
    },
    {
      id: 4,
      name: `วีระวรรณ มโนแจ่ม`,
      profile_image: `https://cdn.vuetifyjs.com/images/lists/4.jpg`
    },
    {
      id: 5,
      name: `มาลี เอกอุดม`,
      profile_image: `https://cdn.vuetifyjs.com/images/lists/5.jpg`
    },
    {
      id: 6,
      name: `วรวุธ ฟักนวล`,
      profile_image: `https://cdn.vuetifyjs.com/images/lists/1.jpg`
    },
    {
      id: 7,
      name: `กิตติพร อวยพร`,
      profile_image: `https://cdn.vuetifyjs.com/images/lists/2.jpg`
    },
    {
      id: 8,
      name: `มณีนุช เชิดกลิ่น`,
      profile_image: `https://cdn.vuetifyjs.com/images/lists/3.jpg`
    },
    {
      id: 9,
      name: `วีระวรรณ มโนแจ่ม`,
      profile_image: `https://cdn.vuetifyjs.com/images/lists/4.jpg`
    },
    {
      id: 10,
      name: `มาลี เอกอุดม`,
      profile_image: `https://cdn.vuetifyjs.com/images/lists/5.jpg`
    }
  ],
  blogPost: [
    {
      tag: `ลูกค้า VIP`,
      textPost: `พรุ่งนี้ทักหาลูกค้า เพื่อเสนอขายสินค้าโปรโมชั่น`,
      picPost: [
        {
          src: `https://picsum.photos/id/11/500/300`
        }
      ],
      userProfile: `https://randomuser.me/api/portraits/women/60.jpg`,
      nameProfile: `ร้านเสนาะการช่าง`,
      datePost: `09/02/20`
    },
    {
      tag: `สินค้าคู่แข่ง`,
      textPost: `ร้าน SmartSmart รุ่งเรืองอำไพ 2`,
      picPost: [
        {
          src: `https://picsum.photos/id/11/500/300`
        },
        {
          src: `https://picsum.photos/id/11/500/300`
        }
      ],
      userProfile: `https://randomuser.me/api/portraits/women/60.jpg`,
      nameProfile: `ร้านเสนาะการช่าง 3`,
      datePost: `10/02/20`
    },
    {
      tag: `สินค้าคู่แข่ง`,
      textPost: `ร้าน SmartSmart รุ่งเรืองอำไพ`,
      picPost: [
        {
          src: `https://picsum.photos/id/11/500/300`
        },
        {
          src: `https://picsum.photos/id/11/500/300`
        },
        {
          src: `https://picsum.photos/id/11/500/300`
        }
      ],
      userProfile: `https://randomuser.me/api/portraits/women/60.jpg`,
      nameProfile: `ร้านเสนาะการช่าง 2`,
      datePost: `10/02/20`
    },
    {
      tag: `สินค้าคู่แข่ง 4`,
      textPost: `ร้าน SmartSmart รุ่งเรืองอำไพ 4`,
      picPost: [
        {
          src: `https://picsum.photos/id/11/500/300`
        },
        {
          src: `https://picsum.photos/id/11/500/300`
        },
        {
          src: `https://picsum.photos/id/11/500/300`
        },
        {
          src: `https://picsum.photos/id/11/500/300`
        },
        {
          src: `https://picsum.photos/id/11/500/300`
        }
      ],
      userProfile: `https://randomuser.me/api/portraits/women/60.jpg`,
      nameProfile: `ร้านเสนาะการช่าง 4`,
      datePost: `10/02/20`
    }
  ]
})

export default {
  namespaced: true,
  state
}
